module.exports = __webpack_public_path__ + "assets/eda8a2c1645fb49362199a55b77802d4.jpg";